<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </router-link>
          </li>
          <li>
            <span> {{
              this.$t('report.company_dashboard.reports')
            }}
            </span>
          </li>
          <li> {{ $t('general.catalog_training_reports') }}</li>
        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span> {{ $t('general.catalog_training_reports') }}</span>
        </h2>
      </div>
    </div>
    <div v-if="error" class="uk-alert-danger mb-3" uk-alert>
      <a class="uk-alert-close" uk-close></a>
      <p style="color: red">
        <i class="uil-exclamation-triangle"></i> {{ error }}
      </p>
    </div>

    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0">
        <div class="d-flex justify-content-between align-items-center">
          <div class="row" style="width:100%">
            <div class=" col-md-1  search-icon ">
              <i class="uil-search"></i>
            </div>
            <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
              <input v-model="filter.search" :placeholder="$t('general.search')" autofocus=""
                class="uk-search-input shadow-0 uk-form-small" type="search" />
            </div>
          </div>

          <div class="d-flex">

            <sort-dropdown :sort-options="sortOption" @sort-selected="sortOrder" />

            <a :uk-tooltip="$t('general.filter_list')" class="btn btn-icon btn-hover btn-circle"
              href="javascript:void(0)">
              <i class="uil-filter"></i>
            </a>

            <UserFilter :assignmentList="assignmentList" :is-catalog-active="true" @getFilter="getFilter($event)" />

            <excel-download-button
                :loading="isReportDownloading"
                :tooltipText="$t('filters.export_excell')"
                @download="exportUserAssignment"
            />
          </div>
        </div>
      </div>
      <!-- Table -->
      <default-loading v-if="user_loading"></default-loading>
      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t("general.username") }}</th>
                <th scope="col">{{ $t("users.user_email") }}</th>
                <th scope="col">{{ $t("users.reg_no") }}</th>
                <th scope="col">{{ $t("general.status") }}</th>
                <!-- <th scope="col">{{ $t("general.assignment_name") }}</th> -->
                <th scope="col">{{ $t("general.content_title") }}</th>
                <th scope="col">{{ $t("general.content_type") }}</th>
                <th scope="col">{{ $t("general.completion_time") }}</th>
                <th scope="col">{{ $t("general.duration_of_training") }}</th>

                <th scope="col">{{ $t("general.start_date") }}</th>
                <!-- <th scope="col">{{ $t("general.end_date") }}</th> -->
                <!-- <th scope="col">{{ $t("general.content_point") }}</th> -->
                <th scope="col">{{ this.$t('general.completion_status') }}</th>
                <th scope="col">{{ $t('excel.heading.completion_date') }}</th>
                <th scope="col">{{ $t("general.created_at") }}</th>
              </tr>
            </thead>

            <tbody class="list">
              <template v-for="item in formattedItems">
                <tr>
                  <td>
                    <span>
                      {{ item.fullname }}</span>
                  </td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.registration_number }}</td>
                  <td>{{ item.user_status }}</td>
                  <!-- <td>{{ item.assignment_name }}</td> -->
                  <td>{{ item.content_name }}</td>
                  <td>{{ item.category }}</td>
                  <td>{{ item.duration }}</td>
                  <td>{{ item.training_duration }}</td>
                  <td>{{ item.start_date }}</td>
                  <!-- <td>{{ item.end_date }}</td> -->
                  <!-- <td>{{ item.completed_status === 'Tamamlandı' ? item.point : '-' }}</td> -->
                  <td v-html="item.completed_status"></td>
                  <td>{{ item.completed_at }}</td>
                  <td>{{ item.created_at }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>
    </div>
  </div>
</template>

<script>
import reports, {
  GET_ITEMS,
  LOADING,
  MODULE_NAME,
  SUCCESS,
} from "@/core/services/store/reports.module";

import store from "@/core/services";
import moment from "moment-timezone";
import axios from "axios";
import UserFilter from "@/view/company/User/Filter";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/assets/components/Pagination";
import SortDropdown from "@/view/components/dropdown/SortDropdown.vue";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter,
} from "@/core/services/userCorporateAccess.service";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "SelfRegistiration",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, reports);
  },
  components: {
    ExcelDownloadButton,
    Pagination,
    UserFilter,
    DefaultLoading,
    SortDropdown
  },
  data() {
    return {
      pagination: null,
      error: null,
      page: 1,
      per_page: 10,
      formattedItems: [],
      assignmentList: [],
      isReportDownloading: false,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      keepFilter: null,
      sortOption: [
        { key: 'text-asc', sort: 'name', order: 'asc', label: this.$t("sorting.a_z") },
        { key: 'text-desc', sort: 'name', order: 'desc', label: this.$t("sorting.z_a") },
        { key: 'created_at-asc', sort: 'created_at', order: 'asc', label: this.$t("sorting.created_at_asc") },
        { key: 'created_at-desc', sort: 'created_at', order: 'desc', label: this.$t("sorting.created_at_desc") },
      ],
    };
  },
  computed: {
    user_loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
  },
  methods: {
    userStatus(statusId) {
      switch (statusId) {
        case 0:
          return this.$t('general.passive');
        case 1:
          return this.$t('general.active');
      }
    },
    formatDuration(value) {
      if (value === null || value === undefined || value === '') return '-';

      const raw = String(value).trim().replace(',', '.');
      if (raw === '-') return '-';

      let totalSeconds;

      if (raw.includes(':')) {
        const parts = raw.split(':').map(Number);
        if (parts.some(Number.isNaN)) return '-';
        const [h, m, s] = parts.length === 3 ? parts : [0, ...parts];
        totalSeconds = h * 3600 + m * 60 + s;
      } else {
        const minutes = Number(raw);
        if (!Number.isFinite(minutes) || minutes < 0) return '-';
        totalSeconds = Math.round(minutes * 60);
      }

      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = Math.floor(totalSeconds % 60);

      return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':');
    },
    exportUserAssignment() {
      if (this.isReportDownloading) {
        return;
      }

      this.isReportDownloading = true;

      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        sort: this.filter.sort,
        order: this.filter.order,
      };
      if (this.keepFilter) {
        const keepFilter = this.keepFilter;

        if (keepFilter.company_id) {
          filters['company_id'] = keepFilter.company_id;
        }

        // {id, name} listesi tutan filtreler API için id dizisine çevrilir
        Object.entries(keepFilter).forEach(([key, value]) => {
          if (!Array.isArray(value) || key === 'company_id') return;

          let ids = value.map((item) => item.id);

          // "Tümü" seçiliyse (id null) training_id gönderilmez
          if (key === 'training_id' && value.some((training) => training?.id === null)) {
            ids = null;
          }

          if (ids?.length > 0) {
            filters[key] = JSON.stringify(ids);
          }
        });
      }

      let url = `${process.env.VUE_APP_BACKEND_APP_URL}/api/report/export/user-trainings?`;
      url += `&sort=${this.filter.sort}`;
      url += `&order=${this.filter.order}`;
      url += `&training_duration=true`;
      url += `&training_id=${filters['training_id']}`;
      if (filters['branch_id']) url += `&branch_id=${filters['branch_id']}`;
      if (filters['department_id']) url += `&department_id=${filters['department_id']}`;
      if (filters['region_id']) url += `&region_id=${filters['region_id']}`;
      if (filters['title_id']) url += `&title_id=${filters['title_id']}`;
      if (filters['position_id']) url += `&position_id=${filters['position_id']}`;
      if (filters['corporate_id']) url += `&corporate_id=${filters['corporate_id']}`;
      if (this.keepFilter?.from_date) url += `&from_date=${this.keepFilter.from_date}`;
      if (this.keepFilter?.to_date) url += `&to_date=${this.keepFilter.to_date}`;
      url += `&report=${Math.random() * 9999999}`;

      axios
        .get(url, {
          responseType: "blob",
          headers: this.apiHeaders,
        })
        .then((response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          let day = moment().format("YYYYMMDDHHMMSS");
          let fileName = "user_assignment_report_list_" + day + ".xlsx";
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isReportDownloading = false;
        })
        .catch(() => {
          this.isReportDownloading = false;
        });
    },
    filterResult(filter = null) {
      this.error = null;

      // Yeni filtre geldiyse sakla; gelmediyse (sayfalama, sıralama, yenileme)
      // en son uygulanan filtreyle devam et
      if (filter) {
        this.keepFilter = filter;
      }

      // İstek her zaman saklanan son filtreden (keepFilter) kurulur
      const activeFilter = this.keepFilter || {};

      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        sort: this.filter.sort,
        order: this.filter.order,
        from_date: activeFilter.from_date || null,
        to_date: activeFilter.to_date || null,
      };

      if (activeFilter.company_id) {
        filters['company_id'] = activeFilter.company_id;
      }

      // {id, name} listesi tutan filtreler API için id dizisine çevrilir
      Object.entries(activeFilter).forEach(([key, value]) => {
        if (!Array.isArray(value) || key === 'company_id') return;

        let ids = value.map((item) => item.id);

        // "Tümü" seçiliyse (id null) training_id gönderilmez
        if (key === 'training_id' && value.some((training) => training?.id === null)) {
          ids = null;
        }

        filters[key] = JSON.stringify(ids);
      });

      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/report/self-trainings",
          filters: filters,
        })
        .then((response) => {

          if (response.status) {
            let results = [];
            let responseData = response.data;
            this.pagination = responseData;

            responseData.data.forEach((item) => {
              let completedStatus = this.$t('general.not_started');

              if (item.started_at) {
                completedStatus = this.$t('general.on_going');
              }

              if (item.completed_at) {
                completedStatus = this.$t('general.completed');
              }

              let userStatus = this.userStatus(item.status_id);
              let registrationNumber = item.registration_number || "-";
              results.push({
                registration_number: registrationNumber,
                user_status: userStatus,
                content_name: item.training_name,
                category: item.training_type_name,
                fullname: item.fullName ?? item.fullname,
                email : item.email,
                duration: this.formatDuration(item.duration),
                training_duration: this.formatDuration(item.training_duration),
                point: item.point,
                start_date: item.started_at
                  ? moment(item.started_at).add(3, 'hours').format("DD/MM/YYYY HH:mm")
                  : "-",
                completed_status: completedStatus,
                completed_at: item.completed_at
                  ? moment(item.completed_at).add(3, 'hours').format("DD/MM/YYYY HH:mm")
                  : "-",
                created_at: item.created_at
                  ? moment(item.created_at).add(3, 'hours').format("DD/MM/YYYY")
                  : "-",
              });
            });
            this.formattedItems = results;
          }
        });
    },
    getAssignments() {
      let self = this;
      let filters = {
        page: 0,
        sort: "id",
        order: "desc",
        per_page: this.per_page,
      };
      store
        .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
          url: "api/report/get-assignments",
          filters: filters,
        })
        .then((response) => {
          self.assignmentList = [
            {
              id: null,
              name: this.$t('general.all'),
            },
          ];
          if (response.status) {
            let items = response.data;
            items.forEach((item) => {
              self.assignmentList.push({
                id: item.id,
                name: item.full_name,
                order_number: item.order_number,
              });
            });
          }
        });
    },
    sortOrder({ order, sort }) {
      this.page = 1;
      this.filter.order = order;
      this.filter.sort = sort;
      this.filterResult();
    },
    setPage(page) {
      this.page = page;
      this.filterResult();
    },
    getFilter(value) {
      this.page = 1
      this.filterResult(value);
    },
  },
  async mounted() {
    // company_admin değilse ve bir şirkete atanmışsa
    // ilk yüklemede sadece o şirketin verisi gelsin.
    // Not: İlk listeleme getAssignments sonrası success watcher'ı ile tetiklendiği
    // için keepFilter, getAssignments çağrılmadan önce hazırlanmalı.
    const corporateAccess = await getAssignedCorporateAccess();
    this.keepFilter = applyAssignedCorporateToFilter(this.keepFilter, corporateAccess);

    this.getAssignments();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },
    "filter.search": function () {
      this.page = 1;
      this.debouncedFilterSearch();
    },
  },
};
</script>

<style scoped>
@import "~vue-multiselect/dist/vue-multiselect.min.css";

input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}
</style>
<style>
.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}

.uk-tooltip {
  word-wrap: break-word;
  font-size: 10px !important;
}
</style>
